.header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

// `.titles`, `.description` and `.actions` are also portalled into the top bar on their own,
// so they stay top-level rather than nesting under `.header`.
.titles {
  min-width: 0;

  .crumbs {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: var(--vc-text-xs);
    color: var(--vc-text-muted);
    margin-bottom: 4px;

    a {
      color: inherit;
    }
  }

  .title {
    font-size: var(--vc-text-xl);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: var(--vc-weight-bold);
    letter-spacing: -0.01em;
    display: flex;
    align-items: center;
    gap: 10px;
  }
}

.description {
  margin-top: 4px;
  font-size: var(--vc-text-sm);
  color: var(--vc-text-muted);

  &.descriptionStandalone {
    margin: 0 0 14px;
  }
}

.actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 10px 12px;
  background: var(--vc-surface);
  border: 1px solid var(--vc-border);
  border-radius: var(--vc-radius-lg);
  box-shadow: var(--vc-shadow-sm);
  margin-bottom: 16px;

  .toolbarSpacer {
    flex: 1;
  }
}

.section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;

  .sectionTitle {
    font-size: var(--vc-text-base);
    font-weight: var(--vc-weight-semibold);
  }

  .sectionSub {
    font-size: var(--vc-text-xs);
    color: var(--vc-text-muted);
    margin-left: 8px;
    font-weight: var(--vc-weight-regular);
  }
}
